import {Mapper} from '@s-ui/domain'

export class FromSubscriptionsParamRequestToApiBodyMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   */
  constructor({config, subscriptionsUserValueObjectFactory}) {
    super()

    this._config = config

    this._externalServicesOffers = this._config.get('user').SUBSCRIPTIONS.EXTERNAL_SERVICES_OFFERS
    this._portalAnnouncements = this._config.get('user').SUBSCRIPTIONS.PORTAL_ANNOUNCEMENTS
    this._subscriptionsByType = {emails: [this._externalServicesOffers, this._portalAnnouncements]}
  }

  transformSubscriptions(subscriptions) {
    return Object.entries(subscriptions).map(([name, isGranted]) => {
      return {name, isGranted: isGranted.value}
    })
  }

  map = subscriptions => {
    return {subscriptions: this.transformSubscriptions(subscriptions)}
  }
}
